
(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentAddController', [
            '$scope', 'config', '$state', 'errorsExtend', '$stateParams', 'documentService', 'documentTypeService', 'auth', 'twainCapture',
            'documentContainerService', 'authExtend', 'storageService', 'fileService', 'containerTypeService',
            function documentController($scope, config, $state, errors, $stateParams, documentService, documentTypeService, auth, twainCapture,
                documentContainerService, authExtend, storageService, fileService, containerTypeService) {

                twainCapture.setFileNameStartIndex();

                $scope.canDigitalize = auth.isInRole('DOCUMENT DIGITALIZATION');
                $scope.canAddToContainer = auth.isInRole('ASSOCIATE CONTAINERS');
                $scope.canAddItemsToComboMetadata = auth.isInRole('METADATA INSERT');
                $scope.showGoBackSearch = false;
                $scope.docContainersPlaceHolder = 'DocumentDocumentContainerPlaceholder';
                $scope.hasNameTemplate = false;
                $scope.hasOrderTemplate = true;

                $scope.changeAsName = function (value) {
                    if (value.updatesName) {
                        $scope.document.name = value.metadataValue;
                    }
                };

                $scope.document = {
                    name: '',
                    documentTypes: [],
                    containers: [],
                    organizationalUnitId: authExtend.getOrganizationId(),
                    isDocumentPerFile: false
                };

                $scope.aux = {
                    files: [],
                    filesTemp: [],
                    metadataReplicate: []
                };

                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.auxDocumentType = {};
                $scope.optionsDocumentTypes = [];
                $scope.metadataAsName = 0;

                $scope.initDocumentFind = function () {
                    if (storageService.getStateBackFind()) {
                        $state.go(storageService.getStateBackFind());
                    }
                };

                documentTypeService.getFunctionsTypes(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                    $scope.optionsDocumentTypes = result.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });

                    if ($scope.optionsDocumentTypes.length === 1) {
                        $scope.selectDocumentType($scope.optionsDocumentTypes[0]);
                        $scope.aux.selectedDocumentTypeid = $scope.optionsDocumentTypes[0].id;
                    }
                }, function (error) {
                    errors.showError(error);
                    $state.go('document-find');
                });

                $scope.loadDocTypeMetadata = function (documentType) {
                    var documentDocType =
                        {
                            documentTypeName: documentType.name,
                            documentTypeId: documentType.id,
                            metadatas: []
                        };

                    documentDocType.metadatas = [];

                    documentType.metadata.forEach(function (metadata) {
                        var meta = {
                            idObject: documentDocType.documentTypeId + '' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataValue: '',
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            maskOptions: metadata.maskOptions,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            metadataAsName: metadata.asName,
                            metadataAttributes: metadata.attributes,
                            metadataIsMultivalue: metadata.isMultivalue,
                            metadataIsUpdateable: (metadata.isUpdateable && $scope.canAddItemsToComboMetadata),
                        };


                        documentDocType.metadatas.push(meta);

                        if (metadata.asName) {
                            if (!$scope.metadataAsName) {
                                // por si cambió el valor mientras se podía.
                                $scope.document.name = '';
                                meta.updatesName = true;
                            }

                            $scope.metadataAsName++;
                        }
                    });

                    $scope.document.documentTypes = [];
                    $scope.document.documentTypes.push(documentDocType);

                    $scope.replicateValues();
                };

                $scope.selectDocumentType = function (documentType) {
                    documentTypeService.getById(documentType.id, 'detail').then(function (result) {
                        $scope.hasNameTemplate = result.nameTemplate !== null;
                        $scope.hasOrderTemplate = result.orderTemplate !== null;
                        $scope.loadDocTypeMetadata(result);
                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-find');
                    });
                };

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file);
                            if (~index) {
                                $scope.aux.files[index] = file;
                            } else {
                                $scope.aux.files.push(file);
                            }
                        }
                    });

                    if ($scope.aux.filesTemp.length === 1
                        && $scope.aux.files.length === 1
                        && $scope.document.name === ''
                        && !$scope.document.metadataAsName) {
                        $scope.document.name = $scope.aux.filesTemp[0].name;
                    }

                    $scope.aux.filesTemp = [];
                };

                $scope.getIndexFile = function (fileNew) {

                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    }
                    return -1;
                };

                $scope.save = function (checkin) {
                    var msj = '';
                    if (!$scope.documentForm.$valid) {
                        $scope.documentForm.$setSubmitted();
                        msj = 'VerifyFormData';
                    }

                    if (msj !== '') {
                        errors.showError(msj);
                        return;
                    }

                    return documentService.create($scope.document, $scope.aux.files, checkin).then(function () {
                        var filter = storageService.getMyDocumentFilter();
                        filter.name = '';

                        storageService.setMyDocumentFilter(filter);
                        $state.go('document-find');
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go('document-find');
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        if ($scope.preview.index === index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.files.splice(index, 1);
                    }
                };

                $scope.previewFile = function (item, index) {

                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileService.preview($scope.aux.files[index], true).then(function (result) {

                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            $scope.hidePreview();
                        }
                    });

                };

                $scope.hidePreview = function () {

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        invalid: false,
                        item: null
                    };
                };

                $scope.nextPreview = function () {
                    if ($scope.preview.index + 1 < $scope.aux.files.length) {
                        $scope.preview.index++;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.prevPreview = function () {
                    if ($scope.preview.index) {
                        $scope.preview.index--;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };

                $scope.metadataCount = function () {
                    if ($scope.document.documentTypes && $scope.document.documentTypes.length) {
                        return $scope.document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) {
                            return valorPrevio + valorActual.metadatas.length;
                        }, 0);
                    }
                    return 0;
                };

                $scope.getReplicatedMetadata = function (metadata) {
                    for (var i = 0; $scope.aux.metadataReplicate.length > i; i++) {
                        if (metadata.metadataId === $scope.aux.metadataReplicate[i].metadataId) {
                            return $scope.aux.metadataReplicate[i];
                        }
                    }

                    return null;
                };

                $scope.replicateValues = function () {
                    for (var k = 0; $scope.document.documentTypes.length > k; k++) {
                        for (var l = 0; $scope.document.documentTypes[k].metadatas.length > l; l++) {
                            var m = $scope.document.documentTypes[k].metadatas[l];
                            var replicated = $scope.getReplicatedMetadata(m);
                            if (replicated) {
                                m.metadataValue = replicated.metadataValue;
                                m.metadataReadOnly = true;
                            } else {
                                m.metadataReadOnly = false;
                            }
                        }
                    }
                };

                $scope.selectContainer = function (item) {
                    var mustReplicateMetadata = false;

                    containerTypeService.getById(item.containerTypeId)
                        .then(function (type) {

                            type.metadata.forEach(function (m) {

                                if (m.isReplicated) {
                                    $scope.aux.metadataReplicate.push({
                                        value: undefined,
                                        metadataId: m.metadataId,
                                        containerId: undefined
                                    });
                                    mustReplicateMetadata = true;
                                }
                            });

                            if (mustReplicateMetadata) {
                                documentContainerService.getById(item.id)
                                    .then(function (container) {
                                        $scope.aux.metadataReplicate.forEach(function loadValues(metadata) {
                                            for (var i = 0; container.metadatas.length > i; i++) {
                                                if (metadata.metadataId === container.metadatas[i].metadataId) {
                                                    metadata.metadataValue = container.metadatas[i].metadataValue;
                                                    metadata.containerId = item.id;
                                                    break;
                                                }
                                            }

                                            $scope.replicateValues();
                                        });
                                    }, function (error) {
                                        if (error && error.status === 403) {
                                            // si no tiene permisos lo dejo seguir. Los datos se van a replicar a nivel de api
                                            return;
                                        }

                                        errors.showError(error);
                                    });
                            }
                        }, function (error) {
                            if (error && error.status === 403) {
                                // si no tiene permisos lo dejo seguir. Los datos se van a replicar a nivel de api
                                return;
                            }

                            errors.showError(error);
                        });

                    var containerTypes = $scope.getContainerTypes();
                    documentTypeService.getByContainerId(containerTypes).then(function (result) {
                        $scope.optionsDocumentTypes = result;
                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-find');
                    });
                };

                $scope.getContainerTypes = function () {
                    var cts = [];

                    $scope.document.containers.forEach(function (container) {
                        if (!(cts.indexOf(container.containerTypeId) > -1)) {
                            cts.push(container.containerTypeId);
                        }
                    });

                    return cts;
                };

                $scope.removeContainer = function (item) {
                    var aux = [];

                    $scope.aux.metadataReplicate.forEach(function (metadata) {
                        if (metadata.containerId !== item.id) {
                            aux.push(metadata);
                        }
                    });

                    $scope.aux.metadataReplicate = aux;
                    $scope.replicateValues();

                    var containertypes = $scope.getContainerTypes();
                    documentTypeService.getByContainerId(containertypes).then(function (result) {
                        $scope.optionsDocumentTypes = result;

                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-find');
                    });
                };

                $scope.beginDigitalization = function () {
                    $scope.digitalizerOpen = true;
                };

                $scope.cancelDigitalization = function () {
                    $scope.digitalizerOpen = false;
                };

                $scope.scanning = false;
                $scope.hasScannedDocument = false;

                $scope.digitalize = function () {

                    $scope.scanning = true;

                    var callback = function () {
                        twainCapture.scanOne()
                            .then(function (index) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            }, function (error) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                                errors.showError(error);
                            });
                    };

                    twainCapture.deleteFirstImage().then(callback, callback);
                };

                $scope.addDigitalized = function () {
                    twainCapture.popImageFile()
                        .then(function (file) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            $scope.aux.filesTemp.push(file);
                            $scope.addFile();
                        }, function (error) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            errors.showError(error);
                        });
                };

                $scope.configureDigitalization = function () {
                    twainCapture.showConfigUi();
                };

                $scope.$watch(function () {
                    return twainCapture.isAvailable();
                }, function (val) {
                    $scope.digitalizerNotAvaliable = !val;
                });
            }
        ]);
})();